var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.b()},[_c('el-progress',{ref:"progress",attrs:{"type":"circle","percentage":_vm.percentage,"color":'#fff',"format":_vm.progressFormat,"width":60}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }